export default __webpack_public_path__ + "static/media/14.f35bb247.jpg";